/* Etiquetas multiidoma en inglés. */
export default {
  "paymentView.paymentReference": "Payment reference",
  "paymentView.paymentType": "Payment type",
  "paymentView.paymentType.CARD": "Card",
  "paymentView.paymentType.CASH": "Cash",
};
